import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';

import { CloseIcon, IcBackIcon } from '@gem/icons';

import { IconButton } from '../IconButton/IconButton';
import { PopupHeaderSteps } from '../PopupHeaderProgress/PopupHeaderSteps';
import styles from './PopupHeader.style.m.css';

export type TPopupHeaderTheme = '1' | '2' | '3';

interface IPopupHeaderProps {
  readonly className?: string;
  readonly contentClassName?: string;
  readonly title?: string;
  readonly children?: ReactNode;
  readonly handlePrevStep?: (() => void) | null;
  onClose?(): void;
  theme?: TPopupHeaderTheme;
  stepsCount?: number;
  currentStep?: number;
}

export const PopupHeader: FC<IPopupHeaderProps> = ({
  title,
  children,
  handlePrevStep,
  onClose,
  className,
  contentClassName,
  theme = '1',
  stepsCount,
  currentStep,
}) => {
  const containerClassNames = classNames(styles[`theme-${theme}`], styles.container, className, {
    [styles.hasActions]: !!(handlePrevStep || onClose),
  });

  const contentClassNames = classNames(styles.content, contentClassName);

  return (
    <div className={containerClassNames}>
      {handlePrevStep && (
        <div className={styles.arrowBlock}>
          <IconButton
            Icon={IcBackIcon}
            onClick={handlePrevStep}
          />
        </div>
      )}
      {title && !children && (
        <div
          className={styles.title}
          title={title}
        >
          {title}
        </div>
      )}
      {!!children && <div className={contentClassNames}>{children}</div>}
      {stepsCount && (
        <>
          <PopupHeaderSteps
            stepsCount={stepsCount}
            currentStep={currentStep}
          />
        </>
      )}
      {onClose && (
        <div className={styles.close}>
          <IconButton
            Icon={CloseIcon}
            dataTest="close-popup"
            onClick={onClose}
          />
        </div>
      )}
    </div>
  );
};
